module.exports = __webpack_public_path__ + "img/banner_en.073f4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_en.png
// module id = 531
// module chunks = 2 3